(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/joker/joker-input.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/joker/joker-input.js');

'use strict';

svs.numbergames.game.views.JokerInput = Marionette.View.extend({
  className: 'joker-row-input-position',
  regions: {
    jokerInputErrorRegion: '#jokerInputErrorRegion'
  },
  ui: {
    input: '.js-joker-input'
  },
  events: {
    'keypress @ui.input': 'keyPressed'
  },
  triggers: {
    'focusout @ui.input': 'focusoutJokerInput',
    'input @ui.input': 'changeJokerInput'
  },
  template(data) {
    return svs.numbergames.game.templates.joker_input(data);
  },
  templateContext() {
    return {
      inputJokerNumbers: this.model.getJokerRowAsString()
    };
  },
  onAttach() {
    this.animations = svs.numbergames.game.animations.joker.getInputAnimations({
      el: this.$el,
      callbackScope: this,
      onShow() {
        this.getUI('input').select();
      },
      onHide() {
        this.constructor.__super__.destroy.apply(this);
      }
    });
    this.animations.show();
  },
  onChangeJokerInput(view, event) {
    if (event.target.validity.valid) {
      this.getRegion('jokerInputErrorRegion').reset();
    }
  },
  onFocusoutJokerInput(view, event) {
    this.inputDone(event);
  },
  keyPressed(e) {
    if (e.keyCode === svs.utils.keylistener.KEY_ENTER) {
      this.inputDone(e);
    }
  },
  inputDone(event) {
    if (event.target.validity.valid) {
      let newJokerRow = event.target.value;

      if (newJokerRow.length && newJokerRow !== this.model.getJokerRowAsString()) {
        newJokerRow = newJokerRow.split('');
        this.model.get('jokerRow').forEach((num, i) => {
          const newNumber = parseInt(newJokerRow[i], 10);
          if (num.number !== newNumber) {
            num.number = newNumber;
            num.manual = true;
          }
        });
        this.model.trigger('change:jokerRow');
      }
      this.model.set({
        jokerIsValid: true
      });
      this.trigger('jokerInputDone', this);
    } else {
      this.model.set({
        jokerIsValid: false
      });
      this.showChildView('jokerInputErrorRegion', () => "<div class=\"joker-number-infobar\">\n          <i class=\"icon icon-exclamation-sign joker-row-error-icon\"></i> Ett giltigt Joker-nummer best\xE5r av 7 siffror.\n        </div>");
    }
  },
  destroy() {
    this.animations.hide();
  }
});

 })(window);